import React, { Component } from 'react';
import { Button, TextArea } from 'grommet';
import rawdomains from "raw-loader!./tlds-alpha-by-domain.txt"; // from http://data.iana.org/TLD/tlds-alpha-by-domain.txt
import { Helmet } from "react-helmet";

const validdomains = rawdomains.split("\n").map(i => i.trim()).filter(i => !i.startsWith("#"));

const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const validate = async (email) => {
    if(!regex.test(email)) {
      return [validate.ERROR, { reason: "Invalid format" }];
    }
    const address = email.split("@");
    const host = address.pop();
    const parts = host.split(".");
    const domains = validdomains; // todo: fetch from config server
    if(!domains.includes(parts.pop().toUpperCase())) {
      return [validate.ERROR, { reason: "Invalid domain" }];
    }

    const data = await fetch(`https://dns.google/resolve?name=${window.encodeURIComponent(host)}&type=mx`);
    const mxrecords = await data.json();
    if(!mxrecords.Answer || !mxrecords.Answer.length) {
      return [validate.ERROR, { reason: "No MX record" }];
    }

    return [validate.OK, { mxrecords, parts }];
};
validate.OK = Symbol("OK");
validate.ERROR = Symbol("ERROR");

const preventDefault = (f, keycode) => (evt) => {
  if (event.keyCode === keycode) { // on enter
      event.preventDefault();
      f(evt);
      return false;
  }
}

export default class EmailValidator extends Component {

    constructor() {
        super();
        this.state = {
            rawemail: "",
            email: [],
            validEmail: []
        };
        this.setEmail = this.setEmail.bind(this);
        this.validateEmail = this.validateEmail.bind(this);


    }

    setEmail(event) {

        const emails = event.target.value;
        const emaillist = emails.split(/[,;]/g).map(rawmail => {
          const email = rawmail.trim();
          const extendedemail = email.match(/^.+<(.+@.+)>$/);
          return extendedemail ? extendedemail[1] : email;
        })

        this.setState ({ email: emaillist, rawemail: emails })
    }

    async validateEmail() {

        const emails = this.state.email;

        const status = emails.map(mail => [mail, "Validating", {}]);
        this.setState ({ validEmail: status });

        const validations = emails.map(async email => {
          const [isValidS, state] = await validate(email);
          return [email, isValidS === validate.OK, state || {}]
        });
        const valitedEmails = await Promise.all(validations);
        // then use await validate("name@example.com.au") => Promise(<[SymbolOK|SymbolError, {....details.....}?]>)

        this.setState ({ validEmail: valitedEmails })
    }

    render() {
        //<> = fragments
        return (<>
          <Helmet>
            <meta charSet="utf-8" />
            <title>Email validator - MD Dashboard</title>
          </Helmet>
            <h1>Welcome to the Email Validator</h1>
            <p>This is a simple and easy to use email validator. To get started simply enter a email into the text box below and we will let you know if the email is valid.  </p>
            <TextArea
                placeholder="Enter your email here"
                value={ this.state.rawemail }
                onChange={ this.setEmail }
                onKeyUp={ preventDefault(this.validateEmail, 13) }
            />
            <p>{this.state.email.join(", ")}</p>
            <p><ul>{this.state.validEmail.map(([email, valid]) => (<li key={email}>{`${email} - ${valid ? "Valid" : "Invalid"}`}</li>))}</ul></p>
            <Button onClick={ this.validateEmail } label ="Validate!"></Button>
        </>);
    }
}
